import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpsertPricesAndPriceableItemsMutationVariables = Types.Exact<{
  input: Types.UpsertPricesAndPriceableItemsInput;
}>;


export type UpsertPricesAndPriceableItemsMutation = { readonly __typename?: 'Mutation', readonly priceListV2: { readonly __typename?: 'PriceListV2Mutations', readonly upsertPricesAndPriceableItems: { readonly __typename?: 'UpsertPricesAndPriceableItemsResponse', readonly totalItemsUpserted: number, readonly totalPricesUpserted: number } } };

export type RevenueDepartmentsAndTariffsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RevenueDepartmentsAndTariffsQuery = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly revenueDepartments: { readonly __typename?: 'RevenueDepartmentsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RevenueDepartment', readonly id: string, readonly name: string }> }, readonly priceTariffs: { readonly __typename?: 'PriceTariffsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'PriceTariff', readonly id: string, readonly name: string }> } } };


export const UpsertPricesAndPriceableItemsDocument = gql`
    mutation upsertPricesAndPriceableItems($input: UpsertPricesAndPriceableItemsInput!) {
  priceListV2 {
    upsertPricesAndPriceableItems(input: $input) {
      totalItemsUpserted
      totalPricesUpserted
    }
  }
}
    `;
export type UpsertPricesAndPriceableItemsMutationFn = Apollo.MutationFunction<UpsertPricesAndPriceableItemsMutation, UpsertPricesAndPriceableItemsMutationVariables>;

/**
 * __useUpsertPricesAndPriceableItemsMutation__
 *
 * To run a mutation, you first call `useUpsertPricesAndPriceableItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPricesAndPriceableItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPricesAndPriceableItemsMutation, { data, loading, error }] = useUpsertPricesAndPriceableItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPricesAndPriceableItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPricesAndPriceableItemsMutation, UpsertPricesAndPriceableItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPricesAndPriceableItemsMutation, UpsertPricesAndPriceableItemsMutationVariables>(UpsertPricesAndPriceableItemsDocument, options);
      }
export type UpsertPricesAndPriceableItemsMutationHookResult = ReturnType<typeof useUpsertPricesAndPriceableItemsMutation>;
export type UpsertPricesAndPriceableItemsMutationResult = Apollo.MutationResult<UpsertPricesAndPriceableItemsMutation>;
export type UpsertPricesAndPriceableItemsMutationOptions = Apollo.BaseMutationOptions<UpsertPricesAndPriceableItemsMutation, UpsertPricesAndPriceableItemsMutationVariables>;
export const RevenueDepartmentsAndTariffsDocument = gql`
    query revenueDepartmentsAndTariffs {
  priceListV2 {
    revenueDepartments {
      edges {
        id
        name
      }
    }
    priceTariffs {
      edges {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useRevenueDepartmentsAndTariffsQuery__
 *
 * To run a query within a React component, call `useRevenueDepartmentsAndTariffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueDepartmentsAndTariffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevenueDepartmentsAndTariffsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRevenueDepartmentsAndTariffsQuery(baseOptions?: Apollo.QueryHookOptions<RevenueDepartmentsAndTariffsQuery, RevenueDepartmentsAndTariffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevenueDepartmentsAndTariffsQuery, RevenueDepartmentsAndTariffsQueryVariables>(RevenueDepartmentsAndTariffsDocument, options);
      }
export function useRevenueDepartmentsAndTariffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevenueDepartmentsAndTariffsQuery, RevenueDepartmentsAndTariffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevenueDepartmentsAndTariffsQuery, RevenueDepartmentsAndTariffsQueryVariables>(RevenueDepartmentsAndTariffsDocument, options);
        }
export type RevenueDepartmentsAndTariffsQueryHookResult = ReturnType<typeof useRevenueDepartmentsAndTariffsQuery>;
export type RevenueDepartmentsAndTariffsLazyQueryHookResult = ReturnType<typeof useRevenueDepartmentsAndTariffsLazyQuery>;
export type RevenueDepartmentsAndTariffsQueryResult = Apollo.QueryResult<RevenueDepartmentsAndTariffsQuery, RevenueDepartmentsAndTariffsQueryVariables>;